import {
  getDataByForeignId,
  getDataByForeignIds
} from '../../services/immutableUtils'

export const getNotesByWeeklyscheduleId = (state, wksId) =>
  getDataByForeignId(state, 'notes', 'weeklyschedule_id', wksId)

export const getNotesByWeeklyscheduleIds = (state, wksIds) =>
  getDataByForeignIds(state, 'notes', 'weeklyschedule_id', wksIds)

export const getNoteById = (state, noteId) => {
  return state.notes.getIn(['data', noteId], null)
}
